import { CSSProperties, FC, ReactNode } from 'react';

import { Container } from './FlexContainer.styles';

interface Props {
	children: ReactNode;
	className?:
		| 'flexStart'
		| 'flexEnd'
		| 'center'
		| 'spaceBetween'
		| 'stretch'
		| string;
	style?: CSSProperties | undefined;
	gap?: CSSProperties['gap'];
	testId?: string;
}

export const FlexContainer: FC<Props> = ({
	children,
	className = 'stretch',
	style,
	gap,
	testId = 'flexContainer',
}) => {
	return (
		<Container
			data-testid={testId}
			className={className}
			style={style}
			gap={gap}
		>
			{children}
		</Container>
	);
};
